import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/maiscontrole-itens-orcamentos/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/maiscontrole-itens-orcamentos/delete`,
        endpoint: `${endpointBackend}gci/maiscontrole-itens-orcamentos/getall`
    }

    let list = {
        labelTitle: 'Mais Controle - Itens de Orçamentos',
        fieldsShowOnDelete: ['descricao'],
        canAdd: false,
        viewActionColumn: false,
        columns: [
            {
                name: 'nome_obra',
                label: 'Obra',
                width: '30%'
            },
            {
                name: 'indice',
                label: 'Índice'
            },
            {
                name: 'etapa_item',
                label: 'Etapa/Item'
            },
            {
                name: 'codigo_item',
                label: 'Código do Item'
            },
            {
                name: 'base',
                label: 'Base'
            },
            {
                name: 'tipo',
                label: 'Tipo'
            },
            {
                name: 'descricao',
                label: 'Descrição',
                width: '25%'
            },
            {
                name: 'unid',
                label: 'Unidade'
            },
            {
                name: 'qtde',
                label: 'Quantidade'
            },
            {
                name: 'custo_unitario_mao_de_obra',
                label: 'Custo Unit. M.O.'
            },
            {
                name: 'custo_unitario_material',
                label: 'Custo Unit. Material'
            },
            {
                name: 'custo_unitario_equipamento',
                label: 'Custo Unit. Equipamento'
            },
            {
                name: 'custo_unitario_outros',
                label: 'Custo Unit. Outros'
            },
            {
                name: 'custo_unitario_item',
                label: 'Custo Unit. Item'
            },
            {
                name: 'custo_total_mao_de_obra',
                label: 'Custo Total M.O.'
            },
            {
                name: 'custo_total_material',
                label: 'Custo Total Material'
            },
            {
                name: 'custo_total_equipamento',
                label: 'Custo Total Equipamento'
            },
            {
                name: 'custo_total_outros',
                label: 'Custo Total Outros'
            },
            {
                name: 'custo_total_item',
                label: 'Custo Total Item'
            },
            {
                name: 'bdi_item',
                label: 'BDI Item'
            },
            {
                name: 'preco_unitario_mao_de_obra',
                label: 'Preço Unit. M.O.'
            },
            {
                name: 'preco_unitario_material',
                label: 'Preço Unit. Material'
            },
            {
                name: 'preco_unitario_equipamento',
                label: 'Preço Unit. Equipamento'
            },
            {
                name: 'preco_unitario_outros',
                label: 'Preço Unit. Outros'
            },
            {
                name: 'preco_unitario_item',
                label: 'Preço Unit. Item'
            },
            {
                name: 'preco_total_mao_de_obra',
                label: 'Preço Total M.O.'
            },
            {
                name: 'preco_total_material',
                label: 'Preço Total Material'
            },
            {
                name: 'preco_total_equipamento',
                label: 'Preço Total Equipamento'
            },
            {
                name: 'preco_total_outros',
                label: 'Preço Total Outros'
            },
            {
                name: 'preco_total_item',
                label: 'Preço Total Item'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                canAdd={list.canAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
